import * as React from 'react';
import { enrichAnalytics } from 'react-shisell';
import { compose, withProps } from 'recompose';
import { cookies } from '@soluto-home-web/platform-core';
import { queryString } from '@soluto-home-web/platform-utils';
import * as queryParametersForAnalytics from './queryParametersForAnalytics';

const getQueryParameter = (parameterName: string, parameterCookieName: string) => {
  const parsedQueryString = queryString.get();
  let parameterValue;

  if (cookies) {
    parameterValue = parsedQueryString[parameterName] || cookies.get(parameterCookieName);
  }
  return parameterValue as string;
};

const setCookieParameter = (name: string, value: string) => {
  cookies && cookies.set(name, value);
};

const withPropsInCookies = (WrappedComponent) =>
  class PropsInCookies extends React.Component<InnerProps> {
    constructor(props: InnerProps) {
      super(props);

      for (const prop of props.analyticMappers) {
        if (prop.value) {
          setCookieParameter(prop.cookiesName, prop.value);
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

type InnerProps = {
  analyticMappers: queryParametersForAnalytics.Mapper[];
};

export default (...mappers: queryParametersForAnalytics.Mapper[]) => (component) => {
  return compose(
    withProps(() => {
      let analyticMappers: queryParametersForAnalytics.Mapper[] = [];
      for (const analyticMapper of mappers) {
        const queryParameterValue = getQueryParameter(analyticMapper.queryParamName, analyticMapper.cookiesName);
        if (queryParameterValue) {
          analyticMapper.value = queryParameterValue.toLowerCase();
          analyticMappers.push(analyticMapper);
        }
      }
      return { analyticMappers };
    }),
    enrichAnalytics((dispatcher, props: InnerProps) => {
      for (const analyticProp of props.analyticMappers) {
        dispatcher =
          analyticProp.analyticType === 'identity'
            ? dispatcher.withIdentity(analyticProp.analyticName, analyticProp.value)
            : dispatcher.withExtra(analyticProp.analyticName, analyticProp.value);
      }
      return dispatcher;
    })
  )(component);
};



// WEBPACK FOOTER //
// ./packages/web-app/src/withQueryParamAnalytics.tsx